// extracted by mini-css-extract-plugin
export var active = "_ce-2";
export var recordingDot = "_ce-1";
export var recordingIndicator = "_ce-0";